export default __webpack_public_path__ + "static/media/SimpleBarChartBlue.6b19ae28.svg";